import { FIRST_GQL_ERRORS_NOTIFICATIONS_SUPPORT } from '@nx/neo4j-sdk/src/types/sdk-types';
import { neo4jVersionUtil } from '@nx/neo4j-version-utils';

import { useConnection } from '../slices/connections';

export const useShowGqlErrorsAndNotifications = (): boolean => {
  const connection = useConnection();
  return connection.versionAndEdition.version !== undefined
    ? neo4jVersionUtil.compareLoose(connection.versionAndEdition.version, FIRST_GQL_ERRORS_NOTIFICATIONS_SUPPORT) >= 0
    : false;
};
